import { BlogItemGrid } from '@graphcommerce/next-ui'
import { useMemo } from 'react'
import { DefaultPageQuery } from '../../graphql/DefaultPage.gql'
import { BlogItem } from './BlogItem'
import { BlogListQuery } from './BlogList.gql'
import { PromotionBlock } from './PromotionBlock'

type PromotionItems =
  | NonNullable<NonNullable<DefaultPageQuery['pages'][0]>['modular']>['components'][0]['blocks']
  | null
  | undefined

type BlogListProps = BlogListQuery & { count?: number } & {
  promotionItems: PromotionItems
}

export function BlogList(props: BlogListProps) {
  const { blogPosts, count, promotionItems } = props
  const blogPostCollection = count ? blogPosts.slice(0, count) : blogPosts

  const list = useMemo(() => {
    const mergedList: (NonNullable<PromotionItems>[0] | BlogListQuery['blogPosts'][0])[] =
      Object.assign([], blogPostCollection)

    promotionItems?.map((item) => mergedList.splice(item.index, 0, item))
    return mergedList
  }, [blogPostCollection, promotionItems])

  return (
    <BlogItemGrid
      maxWidth='lg'
      sx={(theme) => ({
        alignItems: 'flex-start',
        gridTemplateColumns: 'repeat(2, 1fr)',
        mb: theme.spacings.lg,

        '& .BlogMainItem': {
          '& h2': {
            fontSize: theme.typography.h1,
            maxHeight: 'none',
          },
          '& .MuiButton-root': {
            display: 'none',
          },
        },

        [theme.breakpoints.up('md')]: {
          gridTemplateColumns: 'repeat(3, 1fr)',

          '& h2': {
            overflow: { md: 'visible' },
          },
          '& .BlogMainItem': {
            gridColumn: '1/3',
            gridRow: '1/3',
            height: '100%',
            position: 'relative',
            display: 'flex',

            '& > .MuiLink-root': {
              maxHeight: 'none',
              height: '100%',
              width: '100%',
            },
            '& > div.MuiBox-root': {
              position: 'absolute',
              right: 0,
              bottom: 0,
              left: 0,
              pr: 0,
              '& .MuiButton-root': {
                display: 'block',
              },
            },
          },
        },
      })}
      className='BlogItemGrid'
    >
      {list.map((item, index) => {
        if (item.__typename === 'Page') {
          return <BlogItem key={item.title} first={index === 0} {...item} />
        }
        if (item.__typename === 'PromotionBlock') {
          return <PromotionBlock promotionItem={item} />
        }
        return null
      })}
    </BlogItemGrid>
  )
}
